// src/store/rack/RackMinerStore.ts
import { action, makeObservable, observable, runInAction } from 'mobx';
import apiService, { createStore, RequestControl, withLoading } from '@mobx/services/http';
import { GetUsersRequests_RequestTypes } from '@mobx/api/users';
import { UserAditional } from '@services/getUsers';

export const createUsersStore_ = () => (rc: RequestControl) => {

  const getUsers = apiService.createRequest(GetUsersRequests_RequestTypes);

  const self = {
    isLoading: false,
    isLoaded: false,
    users: [] as UserAditional[],

    async updateUsers(): Promise<boolean> {
      const res = await withLoading(self, getUsers(rc.createRequestHandle(), 0, 50));
      if (!res) return false;

      if (res.Status === "success") {
        runInAction(() => {
          self.users = res.Records ?? [];
          self.isLoaded = true;
        });
      }

      return true;
    }
  };

  return makeObservable(self, {
    isLoading: observable,
    isLoaded: observable,
    users: observable,
    updateUsers: action,
  });
};

const createUsersStore = () => createStore(createUsersStore_());
const usersStore = createUsersStore();

export default usersStore;
